import { AuthStore } from '../auth/auth';

export type Environment = {
  appNameSpace: string;
  authUrl: string;
  restApi: string;
  production?: boolean;
  sentryDSN?: string;
  xstateDebug?: boolean;
  patientAppUrl?: string;
};

export class RootStore {
  authStore: AuthStore;
  environment: Environment;

  constructor(environment: Environment) {
    this.environment = environment;
    this.authStore = new AuthStore(this);
  }

  static createRootStore = (environment: Environment) => new RootStore(environment);
}
